import { ToObject } from './262';
/**
 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
 * @param options
 * @returns
 */
export function CoerceOptionsToObject(options) {
  if (typeof options === 'undefined') {
    return Object.create(null);
  }
  return ToObject(options);
}